<template>
    <div>
        <div class="sub_title">
            기타정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">N 검색어</td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="N 검색어를 입력해주세요."
                                v-model="nSearchWord"
                                type="text"
                                @change="parentChange('nSearchWord', nSearchWord)"
                            />
                            <div class="input_error">{{validation.firstError('nSearchWord') }}</div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">N 랭킹순위</td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="N 랭킹순위를 입력해주세요."
                                v-model="nRank"
                                type="text"
                                @change="parentChange('nRank', nRank)"
                            />
                            <div class="input_error">{{validation.firstError('nRank') }}</div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">N 리뷰수 </td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="N 리뷰수를 입력해주세요."
                                v-model="nReview"
                                type="text"
                                @change="parentChange('nReview', nReview)"
                            />
                            <div class="input_error">{{validation.firstError('nReview') }}</div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">N 찜하기수</td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="N 찜하기수를 입력해주세요."
                                v-model="nDibs"
                                type="text"
                                @change="parentChange('nDibs', nDibs)"
                            />
                            <div class="input_error">{{validation.firstError('nDibs') }}</div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">N 카테고리 넘버</td>
                    <td>
                        <div class="d_block">
                            <el-input
                                placeholder="N 카테고리 넘버를 입력해주세요."
                                v-model="nCategory"
                                type="text"
                                @change="parentChange('nCategory', nCategory)"
                            />
                            <div class="input_error">{{validation.firstError('nCategory') }}</div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";
const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    name: "ItemExtraLayout",
    mixins: [],
    components: {},
    props: {
        setComponentData: {
            default: () => {
            }, type: Function
        },
        setValidatorArr: {
            default: () => {
            }, type: Function
        },
        setImportLayoutNames: {default: () => {}, type: Function},
        itemData: {
            default: () => {
            }, type: Object
        },
        itemClass: {default: null,}
    },
    data() {
        return {
            nSearchWord: '' ,//N검색어
            nReview: '', //N리뷰수
            nRank: '', //N랭킹순위
            nDibs: '', //N찜하기수
            nCategory: '', //N 카테고리 넘버
            validatorArr: ['nSearchWord', 'nReview', 'nRank', 'nDibs', 'nCategory'],
        }
    },
    created() {
        if (this.isItemData()) {
            this.settingItemData();
        }
    },
    mounted() {
        this.setValidatorArr(this.validatorArr);
        this.setImportLayoutNames('ItemExtraLayout')
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        isItemData() {
            return !util.isEmpty(this.itemData);
        },
        settingItemData() {
            this.nSearchWord = this.itemData.nSearchWord;
            this.nReview = this.itemData.nReview;
            this.nRank = this.itemData.nRank;
            this.nDibs = this.itemData.nDibs;
            this.nCategory = this.itemData.nCategory;
        },
        parentChange(type, value) {
            this.setComponentData(type, value);
        },
        checkValidator() {
            this.$validate(['nSearchWord', 'nReview', 'nRank', 'nDibs', 'nCategory'])
        },
    },
    watch: {},
    validators: {
        nSearchWord: function (value) {
            return Validator.value(value)
                .required('상품 N 검색어를 입력해주세요.');
        },
        nRank: function (value) {
            return Validator.value(value)
                .required('상품 N 랭킹순위를 입력해주세요.')
                .integer('상품 N 랭킹순위를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 랭킹순위를 입력하세요.')
        },
        nReview : function (value) {
            return Validator.value(value)
                .required('상품 N 리뷰수를 입력해주세요.')
                .integer('상품 N 리뷰수를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 리뷰수를 입력하세요.')
        },
        nDibs: function (value) {
            return Validator.value(value)
                .required('상품 N 찜하기수를 입력해주세요.')
                .integer('상품 N 찜하기수를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 찜하기수를 입력하세요.')
        },
        nCategory: function (value) {
            return Validator.value(value)
                .required('상품 N 카테고리 넘버를 입력해주세요.')
                .integer('상품 N 카테고리 넘버를 입력하세요.')
                .greaterThanOrEqualTo(0, '상품 N 카테고리 넘버를 입력하세요.')
        },
    },
}
</script>

<style scoped>

</style>
